var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LazyHydrate",
    { attrs: { "when-visible": "" } },
    [
      _c(_vm.pagePart && _vm.pagePart.componentName, {
        tag: "component",
        attrs: {
          items: _vm.pagePart && _vm.pagePart.componentItems,
          componentContent: _vm.pagePart && _vm.pagePart.componentContent,
          "items-count": _vm.pagePart && _vm.pagePart.items_count,
          settings: _vm.pagePart && _vm.pagePart.settings
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }